import Search from "./search";
import Chats from "./chats";
import ChatFilter from "./components/chat-filter";

const Sidebar = () => {
  return (
    <div className="__sidebar flex flex-column">
      <Search />
      <ChatFilter />
      <Chats />
    </div>
  );
};

export default Sidebar;
